// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// init Swiper:
const swiper = new Swiper('.swiper.team-homepage', {
  modules: [Navigation, Pagination],

  slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: false, 
  loop: false, 
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1200: {
      slidesPerView: 3.5,
      spaceBetween: 30,
      navigation: {
        enabled: true,
      }
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    0: {
      navigation: {
        enabled: false,  // Wyłączona nawigacja poniżej 1200px
      }
    }
  }
});